import { skipToken, useQuery } from '@tanstack/react-query';

import { getRolesForUser } from '~/services/PromoService';

export const userPromoRolesQueryKeys = {
  all: ['user-promo-roles'] as const,
  detail: (userId: string) => [...userPromoRolesQueryKeys.all, userId] as const,
};

export function useGetUserPromoRoles(userId: string, enabled = true) {
  return useQuery({
    queryKey: userPromoRolesQueryKeys.detail(userId),
    queryFn: userId
      ? async ({ signal }) => {
          const response = await getRolesForUser(userId, { signal });
          if (response.status !== 200) {
            throw new Error(`Failed to fetch user promo roles: ${response.status}`);
          }
          return response.result.roles;
        }
      : skipToken,
    enabled: enabled && Boolean(userId),
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });
}
